 /* eslint-disable */
//  We make use of this 'server' variable to provide the address of the
// REST Janus API. By default, in this example we assume that Janus is
// co-located with the web server hosting the HTML pages but listening
// on a different port (8088, the default for HTTP in Janus), which is
// why we make use of the 'window.location.hostname' base address. Since
// Janus can also do HTTPS, and considering we don't really want to make
// use of HTTP for Janus if your demos are served on HTTPS, we also rely
// on the 'window.location.protocol' prefix to build the variable, in
// particular to also change the port used to contact Janus (8088 for
// HTTP and 8089 for HTTPS, if enabled).
// In case you place Janus behind an Apache frontend (as we did on the
// online demos at http://janus.conf.meetecho.com) you can just use a
// relative path for the variable, e.g.:
//
// 		var server = "/janus";
//
// which will take care of this on its own.
//
//
// If you want to use the WebSockets frontend to Janus, instead, you'll
// have to pass a different kind of address, e.g.:
//
// 		var server = "ws://" + window.location.hostname + ":8188";
//
// Of course this assumes that support for WebSockets has been built in
// when compiling the gateway. WebSockets support has not been tested
// as much as the REST API, so handle with care!
//
//
// If you have multiple options available, and want to let the library
// autodetect the best way to contact your gateway (or pool of gateways),
// you can also pass an array of servers, e.g., to provide alternative
// means of access (e.g., try WebSockets first and, if that fails, fall
// back to plain HTTP) or just have failover servers:
//
//		var server = [
//			"ws://" + window.location.hostname + ":8188",
//			"/janus"
//		];
//
// This will tell the library to try connecting to each of the servers
// in the presented order. The first working server will be used for
// the whole session.
//rafpas@omtdigital.com

/*! jQuery UI - v1.9.2 - 2013-01-04
* http://jqueryui.com
* Includes: jquery.ui.core.js, jquery.ui.widget.js, jquery.ui.mouse.js, jquery.ui.position.js, jquery.ui.draggable.js, jquery.ui.droppable.js, jquery.ui.resizable.js, jquery.ui.selectable.js, jquery.ui.sortable.js, jquery.ui.accordion.js, jquery.ui.autocomplete.js, jquery.ui.button.js, jquery.ui.datepicker.js, jquery.ui.dialog.js, jquery.ui.menu.js, jquery.ui.progressbar.js, jquery.ui.slider.js, jquery.ui.spinner.js, jquery.ui.tabs.js, jquery.ui.tooltip.js, jquery.ui.effect.js, jquery.ui.effect-blind.js, jquery.ui.effect-bounce.js, jquery.ui.effect-clip.js, jquery.ui.effect-drop.js, jquery.ui.effect-explode.js, jquery.ui.effect-fade.js, jquery.ui.effect-fold.js, jquery.ui.effect-highlight.js, jquery.ui.effect-pulsate.js, jquery.ui.effect-scale.js, jquery.ui.effect-shake.js, jquery.ui.effect-slide.js, jquery.ui.effect-transfer.js
* Copyright (c) 2013 jQuery Foundation and other contributors Licensed MIT */

function showContent() {
    $('div#content').removeClass('hidden');
    $('div#loader').addClass('hidden');
}

function hideContent() {
    $('div#content').addClass('hidden');
    $('div#loader').removeClass('hidden');
}
window.hideContent=hideContent;
window.showContent=showContent;

//TODO move navigator.sendbeacon here instead in janus library

var VIDEO_CODECS = ['vp9', 'vp8', 'h264'];
var janusDebug = ['trace', 'error', 'warn'];
//var server = window.videoproxyUrl;
var camNumber;
var janus = null;
var streaming;
var LowStreamList = [];

function createOpaqueId(constant) {
    constant=constant||'streamingtest-';
    return constant + Janus.randomString(12);
}

function handleJSEP(jsep, handler) {
    if (jsep) {

        handler.createAnswer({
            jsep: jsep,
            media: {
                audioSend: false,
                videoSend: false
            }, // We want recvonly audio/video
            success: function (jsep) {
                Janus.debug('Got SDP!');
                Janus.debug(jsep);
                handler.send({
                    message: {request: 'start'},
                    jsep: jsep
                });
            },
            error: function (error, jsep) {
                Janus.error(error);
                streaming.send({
                    message: {request: 'start'},
                    jsep: jsep
                });
            }
        });
    }
}


function initJanusConnection(stunTurnServers, server, videoProxyToken, deviceId, cameraId, onComplete, onError) {
    // Make sure the browser supports WebRTC
    if (!Janus.isWebrtcSupported()) {
        bootbox.alert('No WebRTC support... ');
    } else {
        Janus.init({
            debug: janusDebug,
            callback: function () {
                // Create session
                var janusInstance = new Janus({
                    server: server,
                    headerToken:videoProxyToken,
                    iceServers: stunTurnServers,
                    apisecret: deviceId,
                    //longPollTimeout:24000,
                    //keepAlivePeriod:18000,
                    success: function () {
                        janusInstance.attach({
                            plugin: 'janus.plugin.streaming',
                            opaqueId: createOpaqueId(),
                            success: function (pluginHandler) {
                                onComplete(janusInstance, pluginHandler);
                            },
                            error: function (error) {
                                if (onError && typeof onError === 'function') {
                                    onError(error);
                                }
                            },
                            oncleanup: function () {
                            }
                        });
                    },
                    error: function (error) {
                        Janus.error(error);
                        bootbox.alert(error);
                        if (onError && typeof onError === 'function') {
                            onError(error);
                        }
                    },
                    destroyed: function () {
                        //window.location.reload();
                    }
                });
                janusInstance.cameraId = cameraId;
            }
        });
    }
}


function defaultOnMessage(msg, jsep, handler) {
    console.debug('onmessage', msg);
    if (msg.result) {
        if (msg.result.status) {
            var status = msg.result.status;
            if (handler[status] && typeof handler[status] === 'function') {
                handler[status](msg);
            }
        }
    } else {
        bootbox.alert(msg.error);
        //todo stop stream if started and reload
        stopStream(handler);
    }
    handleJSEP(jsep, handler);
}

function initStreamHandler(janus, onAttached, onRemoteStream, onCleanUp) {
    onAttached = onAttached || function () {
    };
    onRemoteStream = onRemoteStream || function () {
    };
    var handler;
    janus.attach({
        plugin: 'janus.plugin.streaming',
        opaqueId: createOpaqueId(),
        success: function (pluginHandler) {
            handler = pluginHandler;
            onAttached(pluginHandler);
        },
        onmessage: function (msg, jsep) {
            defaultOnMessage(msg, jsep, handler);
        },
        onremotestream: function (streamData) {
            onRemoteStream(streamData);
        },
        error: function (error) {
            Janus.error('  -- Error attaching plugin... ', error);
            bootbox.alert('Error attaching plugin... ' + error);
        },
        oncleanup: function () {
            if (onCleanUp && typeof onCleanUp === 'function') {
                onCleanUp();
            }
        }
    });
}

function retrieveCamList(streaming, onSuccess) {
    console.debug('ask streams list');
    streaming.send({
        message: {request: 'list'},
        success: function (result) {
            if (result === null || result === undefined) {
                bootbox.alert('Got no response to our query for available streams');
                return;
            }
            if (result.list !== undefined && result.list !== null) {
                onSuccess(result.list);
            }
        }
    });
}

function stopStream(handler) {
    if (handler) {
        handler.send({
            message: {
                request: 'stop'
            }
        });
    }
}

function randomString(len, charSet) {
    charSet = charSet || 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    var randomString = '';
    for (var i = 0; i < len; i++) {
        var randomPoz = Math.floor(Math.random() * charSet.length);
        randomString += charSet.substring(randomPoz, randomPoz + 1);
    }
    return randomString;
}

function buildStreamStreamIdKey(id) {
    return 'stream-' + id;
}

function onRemoteDetailStream(stream, handler) {
    var remoteVideo = $('#remote-video-detail');
    remoteVideo.unbind('playing');
    remoteVideo.bind('playing', function () {
        $(remoteVideo).removeClass('hidden');
        $('#cam-detail #waiting-video').addClass('hidden');
        stopSpinner(handler);
    });
    var remoteVideoElem = remoteVideo.get(0);
    var resolution = $('#cam-detail #info-container #resolution');
    var bitRate = $('#cam-detail #info-container #bit-rate');
    var videoState=$('#cam-detail #info-container #state');
    Janus.attachMediaStream(remoteVideoElem, stream);
    var videoTracks = stream.getVideoTracks();
    if (videoTracks && videoTracks.length &&
        (Janus.webRTCAdapter.browserDetails.browser === 'chrome' ||
            Janus.webRTCAdapter.browserDetails.browser === 'firefox' ||
            Janus.webRTCAdapter.browserDetails.browser === 'safari')) {
        handler.bitrateTimer = setInterval(function () {
            // Display updated bitrate, if supported
            computeStats(handler).then(function (stats) {
                bitRate.text(stats.bitrateLabel);
                videoState.removeClass('label-info');
                videoState.removeClass('label-success');
                videoState.removeClass('label-warning');
                videoState.addClass('label-'+stats.level);
            });

            // Check if the resolution changed too
            var width = remoteVideoElem.videoWidth;
            var height = remoteVideoElem.videoHeight;
            if (width > 0 && height > 0) {
                resolution.text(width + 'x' + height);
            }
        }, 1000);
    }
}

function clearHandlersBitRateInterval(streams) {
    if (Array.isArray(streams)) {
        streams.forEach(function (stream) {
            if (stream.bitrateTimer) {
                clearInterval(stream.bitrateTimer);
                stream.bitrateTimer = 0;
            }
        });
    } else {
        clearInterval(streams.bitrateTimer);
        stream.bitrateTimer = 0;
    }
}

function initPtz(janusInstance, onSuccess) {
    janusInstance.attach({
        plugin: 'janus.plugin.ptz',
        opaqueId: createOpaqueId('ptz'),
        success: function (ptzHandler) {
            janusInstance.ptzHandler=ptzHandler;
            ptzHandler.transactionId = randomString(12);
            ptzHandler.send({
                message: {
                    request: "setup"
                }, success: function () {
                    onSuccess(ptzHandler);
                }
            });
        },
        onmessage: function(msg, jsep) {
								if (msg.error !== undefined && msg.error !== null) {
									bootbox.alert(msg.error);
								}
								if (jsep !== undefined && jsep !== null) {
									// Answer
									janus.ptzHandler.createAnswer({
										jsep: jsep,
										media: {
											audioSend: false,
											videoSend: false,
											data: true
										}, // We only use datachannels
										success: function(jsep) {
											janus.ptzHandler.send({
												message: {request:'ack'},
												jsep: jsep
											});
										},
										error: function(error) {
                                            bootbox.alert("WebRTC error... " + error);
                                        }
									});
								}
        },
        error: function (error) {
            bootbox.alert('Error attaching plugin... ' + error);
        }
    });
}

function openCamDetailHighRes(janusInstance, streamItem) {
    janusInstance.attach({
        plugin: 'janus.plugin.videomux',
        opaqueId: createOpaqueId(),
        success: function (videoMuxHandler) {
            videoMuxHandler.transactionId = randomString(12);
            janusInstance.videoMuxHandler = videoMuxHandler;
            janusInstance.videoMuxHandler.send({
                message: {
                    request: "setup"
                }, success: function () {
                    janusInstance.videoMuxHandler.send({
                        message: {
                            request: 'videomux',
                            videomux: 'open',
                            transaction: videoMuxHandler.transactionId
                        },
                        success: function (message) {
                            if (message.videomux === 'success') {
                                streamItem.selectedSlot = message.slot;
                                janusInstance.videoMuxHandler.send({
                                    message: {
                                        request: 'videomux',
                                        videomux: "watch",
                                        cam: streamItem.id,
                                        transaction: videoMuxHandler.transactionId
                                    },
                                    success: function (watchResponse) {
                                        if (watchResponse.videomux === 'success') {
                                            janusInstance.videoMuxHandler.xaddress =watchResponse.xaddress;
                                            var gridContainer = $('#cam-grid');
                                            var detailContainer = $('#cam-detail');
                                            setTimeout(function () {
                                                LowStreamList.forEach(function (lowStream) {
                                                    clearHandlersBitRateInterval(lowStream);
                                                    cleanStream(lowStream);
                                                });
                                            });
                                            gridContainer.addClass('hidden');
                                            detailContainer.removeClass('hidden');
                                            showContent();
                                            initStreamHandler(janusInstance, function (detailStreamHandler) {
                                                detailStreamHandler.send({
                                                    message: {
                                                        request: 'watch',
                                                        id: streamItem.selectedSlot
                                                    }
                                                });
                                                janusInstance.detailStreamHandler = detailStreamHandler;
                                                var state = $('#cam-detail #info-container #state');
                                                detailStreamHandler.preparing = function () {
                                                    state.text('preparing');
                                                };
                                                detailStreamHandler.clearUp = function () {
                                                };
                                                detailStreamHandler.started = function () {
                                                    state.text('started');
                                                };
                                                detailStreamHandler.starting = function () {
                                                    state.text('starting');
                                                };
                                                detailStreamHandler.stopped = function () {
                                                    state.text('stopped');
                                                };
                                                detailStreamHandler.removed = function () {
                                                    state.text('');
                                                    detailStreamHandler.spinner = null;

                                                };
                                                //detailStreamHandler.spinner = new Spinner();
                                                //detailStreamHandler.spinner.spin(detailContainer.get(0));
                                            }, function (streamInstance) {
                                                //detailStreamHandler.onRemoteStreamUpdateView()
                                                onRemoteDetailStream(streamInstance, janusInstance.detailStreamHandler);
                                            });
                                            if(janusInstance.videoMuxHandler.xaddress&&janusInstance.videoMuxHandler.xaddress.length>0){
                                                initPtz(janusInstance, function (ptzHandler) {
                                                janusInstance.ptzHandler = ptzHandler;
                                                $('#ptz-command-move').removeClass('hidden');
                                                $('#ptz-command-zoom').removeClass('hidden');

                                                ptzHandler.sendCommand = function (command) {
                                                    var message = {
                                                            ptz: "message",
                                                            cam: janusInstance.videoMuxHandler.xaddress,
                                                            command: command,
                                                            transaction: janusInstance.ptzHandler.transactionId
                                                    };
                                                    janusInstance.ptzHandler.data({text:JSON.stringify(message)});
                                                };

                                                $('.ptz-button').each(function (index, button) {
                                                    button = $(button);
                                                    button.mousedown(function () {
                                                        ptzHandler.sendCommand(button.attr('data-command'));
                                                    });
                                                    button.mouseup(function () {
                                                        ptzHandler.sendCommand('stop');
                                                    });
                                                });
                                            });
                                            }
                                        } else {
                                            bootbox.alert(watchResponse.error);
                                            showContent();
                                        }
                                    }
                                });
                            } else {
                                bootbox.alert(message.error);
                                showContent();
                            }
                        }
                    });
                }
            });


        },
        error: function (error) {
            Janus.error('  -- Error attaching plugin... ', error);
            bootbox.alert('Error attaching plugin... ' + error);
            showContent();
        },
        oncleanup: function () {
        }
    });
}

function drawCamTile(streamItem, streamsContainer, janus, index) {
    var camOffset = '';
    var realCamNumber = LowStreamList.length;
    if (realCamNumber <= 3 && index === 0) {
        switch (realCamNumber) {
            case 1:
                camOffset = 'col-md-offset-4';
                break;
            case 2:
                camOffset = 'col-md-offset-3';
                break;
            default:
                camOffset = 'col-md-offset-1';
                break;
        }
        streamItem.offset = camOffset;
    }
    var id = buildStreamStreamIdKey(streamItem.id);
    var container = $('<div class="cam-container col-md-3 ' + camOffset + '" id="' + id + '"></div>');
    var panel = $('<div class="panel panel-default"></div>');
    var infoContainer = $('<div id="info-container" class="panel-heading"></div>');
    streamsContainer.append(container);
    container.append(panel);
    var streamContainer = $('<div class="panel-body" id="' + id + '"></div>');
    panel.append(infoContainer);
    panel.append(streamContainer);
    streamContainer.append('<video id="waiting-video-' + id + '" width="100%" height=240 ></video>');
    var videoContainerSelector = 'div#stream-' + streamItem.id;
    var remoteVideoId = 'remote-video-' + streamItem.id;
    var remoteVideoSelector = videoContainerSelector + '  #' + remoteVideoId;
    var waitingVideoSelector = videoContainerSelector + ' #waiting-video-stream-' + streamItem.id;
    var bitRate = $('<span class="label label-info" id="bit-rate"></span>');
    var videoState = $('<span class="label label-info" id="state">loading</span>');
    var resolution = $('<span class="label label-primary" id="resolution"></span>');
    infoContainer.append(videoState);
    infoContainer.append(resolution);
    infoContainer.append(bitRate);
    var remoteVideo = $('<video class="hidden" id="' + remoteVideoId + '" width="100%" height=240  autoplay></video>');
    streamContainer.append(remoteVideo);
    var remoteVideoElem = remoteVideo.get(0);
    $(window).resize(function() {
        if(window.innerWidth <= 215) { 
            resolution.parent('#info-container').addClass('tooSmall');
        }
        else { 
            resolution.parent('#info-container').removeClass('tooSmall');
        }
    });
    
    streamItem.showBigger = function () {
        $('.row#cam-grid >.cam-container').each(function (index, item) {
            item = $(item);
            if (item.attr('id') === id) {
                item.removeClass('col-md-3');
                item.addClass('col-md-12');
                remoteVideo.css('height', 'auto');
                remoteVideo.unbind('click');
                if (streamItem.offset && item.hasClass(streamItem.offset)) {
                    item.removeClass(streamItem.offset);
                }
                var backBtn = $('<button class="btn btn-default margin-top-10 center-block" id="back-to-grid" style="display:none">Indietro</button>');
                var highResBtn = $('<button style="display:none" class="btn btn-default btn-sm" id="high-res">HIGH RESOLUTION</button>');
                backBtn.click(function () {
                    highResBtn.remove();
                    backBtn.remove();
                    item.removeClass('col-md-12');
                    item.addClass('col-md-3');
                    remoteVideo.bind('click', streamItem.showBigger);
                    remoteVideo.css('height', '240px');
                    if (streamItem.offset) {
                        item.addClass(streamItem.offset);
                    }
                    $('.row#cam-grid >.cam-container').each(function (index, el) {
                        el = $(el);
                        el.removeClass('hidden');
                    });
                });
                //streamContainer.append(backBtn);
                setTimeout(function () {
                    infoContainer.append(highResBtn);
                });
                highResBtn.click(function () {
                    highResBtn.prop('disabled', true);
                    hideContent();
                    openCamDetailHighRes(janus, streamItem);
                    var backToGridBtn = $('<button class="btn btn-default" id="back-to-grid">Torna alla griglia</button>');
                    backToGridBtn.bind('click', function () {
                        hideContent();
                        $('#ptz-command-move').addClass('hidden');
                        $('#ptz-command-zoom').addClass('hidden');
                        clearHandlersBitRateInterval(janus.detailStreamHandler);
                        initStreamGrid(janus);
                        stopStream(janus.detailStreamHandler);
                        setTimeout(function () {
                            resolution.text('');
                            bitRate.text('');
                            backToGridBtn.remove();
                            $('#cam-detail #waiting-video').removeClass('hidden');
                            $('#cam-detail #remote-video-detail').addClass('hidden');
                        });
                        janus.videoMuxHandler.send({
                            message: {
                                request: 'videomux',
                                videomux: 'stop',
                                transaction: janus.videoMuxHandler.transactionId
                            }
                        });
                        janus.videoMuxHandler.send({
                            message: {
                                request: 'videomux',
                                videomux: 'close',
                                transaction: janus.videoMuxHandler.transactionId
                            }
                        });
                        janus.detailStreamHandler.hangup();
                    });
                    setTimeout( function() {
                        $('#cam-detail #back-btn-container').append(backToGridBtn);
                    }, 2000);
                });
            } else {
                item.addClass('hidden');
            }
        });
    };
    streamItem.onRemoteStreamUpdateView = function (remoteStream) {
        remoteVideo.unbind('playing');
        remoteVideo.bind('playing', function () {
            console.debug('playing');
            $(remoteVideoSelector).removeClass('hidden');
            $(waitingVideoSelector).remove();
            streamItem.stopSpinner();
        });
        remoteVideo.unbind('click');
        remoteVideo.bind('click', streamItem.showBigger);
        Janus.attachMediaStream(remoteVideoElem, remoteStream);
        var videoTracks = remoteStream.getVideoTracks();
        if (videoTracks && videoTracks.length &&
            (Janus.webRTCAdapter.browserDetails.browser === 'chrome' ||
                Janus.webRTCAdapter.browserDetails.browser === 'firefox' ||
                Janus.webRTCAdapter.browserDetails.browser === 'safari')) {
            streamItem.bitrateTimer = setInterval(function () {
                computeStats(streamItem.streamingPlugin).then(function (stats) {
                    bitRate.text(stats.bitrateLabel);
                    videoState.removeClass('label-info');
                    videoState.removeClass('label-success');
                    videoState.removeClass('label-warning');
                    videoState.addClass('label-'+stats.level);
                });
                // Check if the resolution changed too
                var width = remoteVideoElem.videoWidth;
                var height = remoteVideoElem.videoHeight;
                if (width > 0 && height > 0) {
                    resolution.text(width + 'x' + height);
                }
            }, 1000);
        };
    };
    streamItem.updateStateLabel = function (text) {
        videoState.text(text);
    };
    streamItem.startSpinner = function () {
        //streamItem.spinner = new Spinner();
        //streamItem.spinner.spin(document.getElementById(id));
    };
    streamItem.stopSpinner = function () {
        stopSpinner(streamItem);
    };
    streamItem.updateViewForStart = function () {
        streamItem.updateStateLabel('started');
        streamItem.showBigger();
    };
    streamItem.updateViewForStop = function () {
        resolution.remove();
        bitRate.remove();
        streamItem.updateStateLabel('stopped');
    };
}

function stopSpinner(stream) {
    if (stream.spinner) {
        stream.spinner.stop();
        delete stream.spinner;
    }
}

function computeStats(handler) {
    //todo should be inserted in webrtc library
    var config = handler.webrtcStuff.pc;
    return config.getStats().then(function (stats) {
        config.stats = config.stats || {
            level:'info'
        };
        stats.forEach(function (item) {
            var isStat = false;
            if ((item.mediaType && item.mediaType.toLowerCase() === 'video') || item.id.toLowerCase().includes('video')) {//firefox check
                //TODO add other checks on firefox neeed to be analized
                //check type=inbound-rtp && id.includes('rtcp')
            }
            if (!!(item.type === 'ssrc' || item.googCodecName)) {
                isStat = VIDEO_CODECS.indexOf(item.googCodecName.toLowerCase()) > -1;
            }
            isStat = isStat && item.bytesReceived;
            if (isStat) {
                config.stats.bytesReceivedNow = item.bytesReceived;
                config.stats.timestampNow = item.timestamp;
                if (!config.stats.bytesReceivedBefore || !config.stats.timestampBefore) {
                    config.stats.bytesReceivedBefore = item.bytesReceived;
                    config.stats.timestampBefore = item.timestamp;
                    config.stats.bitrate = 0;
                } else {
                    var timePassed = config.stats.timestampNow - config.stats.timestampBefore;
                    if (Janus.webRTCAdapter.browserDetails.browser === "safari") {// Apparently the timestamp is in microseconds, in Safari TODO TEST IT
                        timePassed = timePassed / 1000;
                    }
                    config.stats.bitrate = Math.round((config.stats.bytesReceivedNow - config.stats.bytesReceivedBefore) * 8 / timePassed);
                    config.stats.bytesReceivedBefore = item.bytesReceived;
                    config.stats.timestampBefore = item.timestamp;
                }
            }
            if(item.googLocalCandidateType && item.googLocalCandidateType){
                if (item.googLocalCandidateType==='stun' && item.googLocalCandidateType==='stun'){
                    config.stats.level='success';
                }else{
                    config.stats.level='warning';
                }
            }
            config.stats.bitrateLabel = (config.stats.bitrate || 0) + ' kbits/sec';
        });
        return config.stats;
    });
}

function drawStreamAndPlay(janus, streamItem, container, index) {
    drawCamTile(streamItem, container, janus, index);
    setTimeout(function () {
        console.debug('starting stream handler ' + streamItem.id, new Date().toISOString());
        initStreamHandler(janus,
            function (streamInstanceHandler) {
                //onAttacched
                streamItem.streamingPlugin = streamInstanceHandler;
                streamItem.startSpinner();
                //description type check other field usage
                console.debug('attacched stream handler  asking watch' + streamItem.id, new Date().toISOString());

                streamItem.streamingPlugin.send({
                    message: {
                        request: 'watch',
                        id: streamItem.id
                    }
                });
                streamInstanceHandler.preparing = function () {
                    console.debug('stream ' + streamItem.id + ' preparing handlerId: ' + streamInstanceHandler.id, new Date().toISOString());
                    streamItem.updateStateLabel('preparing');
                };
                streamInstanceHandler.clearUp = function () {
                };
                streamInstanceHandler.started = function () {
                    console.debug('stream ' + streamItem.id + ' started handlerId: ' + streamInstanceHandler.id, new Date().toISOString());
                    streamItem.updateViewForStart();
                };
                streamInstanceHandler.starting = function () {
                    console.debug('stream ' + streamItem.id + ' starting handlerId: ' + streamInstanceHandler.id, new Date().toISOString());
                    streamItem.updateStateLabel('starting');
                };
                streamInstanceHandler.stopped = function () {
                    console.debug('stream ' + streamItem.id + ' stopped handlerId: ' + streamInstanceHandler.id, new Date().toISOString());
                    streamItem.updateViewForStop();
                };
            }, function (streamInstance) {
                console.debug('remote stream called ' + streamItem.id, new Date().toISOString());
                streamItem.onRemoteStreamUpdateView(streamInstance);
            }, streamItem.updateViewForStop);
    });
}

function cleanStream(stream) {
    clearHandlersBitRateInterval(stream.bitrateTimer);
    if (stream.streamingPlugin) {
        stopStream(stream.streamingPlugin);
        stream.streamingPlugin.hangup();
    }
}

var initStreamGrid = function (janusInstance) {
    initStreamHandler(janusInstance, function (streamingHandler) {
        //onAttacched
        janusInstance.mainStreamHandler = streamingHandler;
        console.debug('main stream handler init', new Date().toISOString());
        retrieveCamList(streamingHandler, function (camList) {
            console.debug(camList);

            if (janusInstance.cameraId !== undefined){
                LowStreamList = camList.filter(function (item) {
                    return item.id == janusInstance.cameraId;
                });
            } else {

                LowStreamList = camList.filter(function (item) {
                    return !item.description.includes('High');
                });
            }
            var gridContainer = $('#cam-grid');
            $('#cam-detail').addClass('hidden');
            gridContainer.removeClass('hidden');
            gridContainer.empty();
            console.debug('retrieved stream list complete', new Date().toISOString());
            LowStreamList.forEach(function (streamItem, index) {
                drawStreamAndPlay(janusInstance, streamItem, gridContainer, index);
            });
            showContent();
        });
    });
};

var initGridHavingCamInfo = function (janusInstance) {
    LowStreamList = Array.apply(null, {length: camNumber}).map(function (item, index) {
        return {id: index + 1};
    });
    console.log(LowStreamList);
    var gridContainer = $('#cam-grid');
    $('#cam-detail').addClass('hidden');
    gridContainer.removeClass('hidden');
    gridContainer.empty();
    console.debug('retrieved stream list complete', new Date().toISOString());
    console.log(LowStreamList);
    LowStreamList.forEach(function (streamItem, index) {
        drawStreamAndPlay(janusInstance, streamItem, gridContainer, index);
    });
    showContent();
};

if (camNumber !== undefined && camNumber !== null) {
    initStreamGrid = initGridHavingCamInfo;
}

function formatStunServerUri(data) {
    var server = [];
    if (!data) {
        return server;
    }
    if (Array.isArray(data)) {
        server = server.concat(data);
    } else {
        if (typeof data === 'string') {
            server.push({urls: data});
        } else {
            data.urls = data.urls || data.url;
            server.push(data);
        }
    }
    return server;
}


function videoStartRendering(stunServer, turnServer, server, videoProxyToken, deviceId, cameraId){

    var stunServers = formatStunServerUri(stunServer);
    stunServers = stunServers.concat(formatStunServerUri(turnServer));
    console.log(stunServers);
    console.debug('starting', new Date().toISOString());
        initJanusConnection(stunServers, server, videoProxyToken, deviceId, cameraId, function (janusInstance) {
            janus = janusInstance;
            console.debug(janus);
            console.debug('janus init', new Date().toISOString());
            initStreamGrid(janusInstance);
        }, function () {
            showContent();
            $('#cam-grid').text("Errore imprevisto riprova più tardi");
        });


};
